export const selectQuestions = (state) => state?.exam?.questions;
export const selectCurrentQuestion = (state) => state?.exam?.questions[state.exam.currentQuestionIndex];
export const selectTimer = (state) => state?.exam?.timer;
export const selectUserResponses = (state) => state?.exam?.userResponses;
export const selectResult = (state) => state?.exam?.result;
export const selectError = (state) => state?.exam?.error;